import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { selectUsers } from '../store/usersSlice';
import { getUserData } from "../../firebase";

const PersonalSettings = () => {
  const user = useSelector(selectUsers);
  const [ userData, setUserData ] = useState({});

  useEffect(() => {
    const userInformation = async() => {
      const results = await getUserData(user.currentUser?.id);
      setUserData(results);
    }
  
     userInformation();
  },[user.currentUser])

  return (
    <>
      <ul>
        <li>email: {user.currentUser.email}</li>
        <li>join date: {userData.joined}</li>
      </ul>
    </>
  )
}

export default PersonalSettings;